import { select } from '@ngneat/elf';
import { Injectable } from '@angular/core';
import { dynamicFormInitialState, DynamicFormProps, dynamicFormStore } from './dynamic-form.store';
import { BaseStoreRepository } from '../base-store.repository';
import { DynamicForm } from '@/types';

@Injectable({ providedIn: 'root' })
export class DynamicFormRepository extends BaseStoreRepository<DynamicFormProps> {
  constructor() {
    super(dynamicFormStore.pipe(select(state => state)), dynamicFormStore, dynamicFormInitialState);
  }

  setDynamicFormDto(response: DynamicForm): void {
    this.set('response', response);
    this.set('dto', {
      id: response.id,
      name: response.name,
      order: response.order,
      typeDossierId: response.typeDossier.id,
      formType: response.formType,
      status: response.status,
    });
    this.set('typeSelected', { name: response.typeDossier.libelle, code: response.typeDossier.id });
    this.set('formTypeSelected', { name: response.formType, code: response.formType });
  }
}
